import directives from './module';
import {AuthenticationSvc} from '../services/AuthenticationSvc';

class StudioHeader implements ng.IComponentController {
    constructor(private $state: ng.ui.IStateService,
                public AuthenticationSvc: AuthenticationSvc) {
    }

    handlerClickLogin() {
        options.handHeld ? this.$state.go('studio-login') : this.AuthenticationSvc.toggleLoginModal()
    }
}

directives.component('studioHeader', {
    controller: StudioHeader,
    templateUrl: require('studio-header.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/studioHeader.ts